//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    data () {
        return {
            model: ''
        }
    },
    methods: {
        
    },
    mounted: function() {
        
    }
}
